export default {
  // 模式
  "common.mode.auto": "Modalità di autoconsumo automatico dell'energia prodotta",
  "common.mode.economy": "Modalità economica",
  "common.mode.exigency": "Modalità di emergenza",

  // 设备
  "common.grid": "Rete elettrica",
  "common.evChargers": "Caricabatterie per veicoli elettrici",
  "common.evCharger": "Caricabatterie per veicolo elettrico",
  "common.pv": "Energia fotovoltaica (PV)",
  "common.inverter": "Inverter",
  "common.pcs": "Inverter + batteria",
  "common.terminal": "Dispositivo terminale",
  "common.airc": "Aria condizionata",
  "common.engine": "Motore",
  "common.battery": "Batteria",
  "common.metter": "Contatore elettrico",
  "common.other": "Altro",
  "common.power": "Potenza",
  "common.powerTotal": "Potenza totale",
  "common.voltage": "Tensione",
  "common.electricity": "Energia elettrica",
  "common.current": "Corrente",
  "common.homeUsage": "Carico totale della casa",
  "common.battery.power": "Potenza della batteria",

  // 数据
  "common.noDataAvailable": "Nessun dato disponibile al momento~",
  "common.tips": "Suggerimento",
  "common.reset": "Reimposta",
  "common.currencyUnit": "¥",
  "common.submiting": "Invio in corso... Attendi, per favore...",
  "common.close": "Chiudi",
  "common.from": "Da",
  "common.useIn": "Per",
  "common.energyPercent": "Percentuale di flusso energetico",
  "common.dataFlow": "Flusso di dati",
  "common.getDataIng": "Recupero dati in corso... Attendi, per favore...",
  "common.pageLoading": "Caricamento contenuto pagina in corso... Attendi, per favore...",
  "common.reseting": "Reimpostazione contenuto pagina in corso... Attendi, per favore...",
  "common.save": "Salva",
  "common.onlyNumberTips": "È possibile inserire solo numeri",
  "common.offline": "Offline",
  "common.online": "Online",
  "common.fault": "Errore",
  "common.charge": "Carica",
  "common.discharge": "Scarica",
  "common.buy": "Compra",
  "common.sell": "Vendi",
  "common.loadingInfo": "Caricamento in corso... Attendi, per favore...",

  // 通用功能
  "common.moreFeatures": "Altre funzionalità",
  "common.confirm": "Conferma",
  "common.saveing": "Salvataggio in corso... Attendi, per favore...",
  "common.searchPlacholder": "Inserisci una parola chiave per la ricerca",
  "common.iSee": "Capisco",
  "common.pageErrorTips1": "Oh, si è verificato un errore sulla pagina~",
  "common.pageErrorTips2": "Prova ad aggiornare la pagina o contatta il supporto~",
  "common.refresh": "Aggiorna",
  "common.backToHome": "Torna alla pagina iniziale",
  "common.checkTips": "Verifica in corso... Attendi, per favore...",
  "common.back": "Indietro",
  "common.cancel": "Annulla",
  "common.optional": "Facoltativo",
  "common.required": "Obbligatorio",
  "common.status": "Stato",
  "common.statusNoDelete": "Non eliminato",
  "common.statusDelete": "Eliminato",
  "common.submit": "Invia",
  "common.disable": "Disattiva",
  "common.enable": "Attiva",
  "common.year": "anno",
  "common.month": "mese",
  "common.day": "giorno",
  "common.version": "Versione:",
  "common.backHome": " Torna alla pagina iniziale",
  "common.backHomeSorry": "Mi dispiace, la pagina ha perso per errore il percorso",
  "common.requestTips1": "Elaborazione dati in corso, non inviare di nuovo",
  "common.requestTips2": "Notifiche di sistema",
  "common.requestTips3": "La sessione è scaduta, accedi di nuovo",
  "common.requestTips4": "Accedi di nuovo",
  "common.requestTips5": "Sessione non valida o scaduta, accedi di nuovo.",
  "common.requestTips6": "Errore del server, si prega di riprovare più tardi.",
  "common.requestTips7": "Tempo di richiesta per l'interfaccia di sistema scaduto",
  "common.requestTips8": "Interfaccia di sistema",
  "common.requestTips9": "Errore",
  "common.iknow": "Capisco",
  "common.logoutSuccess": "Logout effettuato con successo",
  
  // 了解更多组件
  "common.knowMore.title": "Per ulteriori informazioni, contatta Beineng",
  "common.knowMore.email": "Email per contatti",
  "common.knowMore.phone": "Telefono per contatti",
  "common.knowMore.wechat": "WeChat per contatti",
  "common.knowMore.website": "Indirizzo del sito ufficiale",
  "common.knowMore.address": "Indirizzo per contatti",
  "common.knowMore.addressDetail": "Appartamenti 1205, 1301, Edificio 5, Via Qinghe 8, Villaggio Huangjingkeng, Distretto Huangjiang, Città Dongguan, Provincia di Guangdong",
  
  // 本地连接组件
  "common.localConnection": "Connessione locale",
  "common.operateInApp": "Esegui l'operazione nell'app!",
  
  "common.enbleStaus": "Stato di attivazione",
  "common.battery.status": "Nessuna carica o scarica",

  // 账户相关
  "account.forgetThePassword": "Ho dimenticato la password",
  "account.logInDirectly": "Accedi direttamente",
  "account.tips1": "Reindirizzamento alla pagina... Attendi, per favore...",
  "account.tips2": "Prima leggi e accetta i termini di servizio!",
  "account.autoLogin": "Accesso automatico",
  "account.userLogin": "Accesso utente",
  "account.registerTips": "Non hai ancora un account? Clicca qui per registrarti",
  "account.userEmail": "Nome utente / Email",
  "account.userEmailTips": "Inserisci il nome utente o l'email",
  "account.password": "Password",
  "account.passwordTips": "Inserisci la password",
  "account.submit": "Invia",
  "account.submitTips": "Invio in corso... Attendi, per favore...",
  "account.otherLoginTips": "Oppure seleziona un altro metodo di accesso",
  "account.userRegistration": "Registrazione utente",
  "account.userName": "Nome utente",
  "account.userNameTips": "Inserisci il nome utente",
  "account.emailTips1": "Inserisci l'indirizzo email",
  "account.emailTips2": "Formato email non valido",
  "account.phone": "Numero di telefono",
  "account.phoneTips1": "Inserisci il numero di telefono",
  "account.phoneTips2": "Numero di telefono non valido",
  "account.phoneTips3": "Inserisci il numero di telefono",
  "account.passwordTips1": "Inserisci la password (6-30 caratteri)",
  "account.passwordTips2": "Formato password non valido: la password deve contenere lettere inglesi, numeri, underscore, trattini e punti, lunghezza 6-12 caratteri",
  "account.passwordTips3": "Le due password inserite non corrispondono, verifica e inserisci di nuovo!",
  "account.passwordTips4": "Inserisci la password: la password deve contenere lettere inglesi, numeri, underscore, trattini e punti",
  "account.passwordTips5": "Conferma password",
  "account.passwordTips6": "Inserisci la conferma della password",
  "account.passwordTips7": "Le due password inserite non corrispondono, verifica e inserisci di nuovo!",
  "account.passwordTips8": "Inserisci la conferma della password",
  "account.passwordTips9": "Congratulazioni, registrazione effettuata con successo!",
  "account.passwordTips10": "Il tuo nome utente è:",
  "account.emailIs": "L'email è:",
  "account.goToLoginPage": "Sarai reindirizzato automaticamente alla pagina di accesso tra s secondi",
  "account.goLogin": "Accedi",
  "account.goRegister": "Registrati",
  "account.loginSuccess": "Accesso effettuato con successo",
  "account.email": "Email",
  "account.sologn": "Creiamo con cura un piano energetico personalizzato per te",
  "account.pleaseAgree": "Ho letto e accettato i",
  "userAgreement.privacyPolicy": "informativa sulla privacy",

  // 验证码相关
  "account.code": "Codice di verifica",
  "account.codeTips": "Inserisci il codice di verifica",
  "account.codeTips2": "Codice di verifica non valido",

    "account.inviteCodeTips": "Inserisci il codice di invito",
    "account.inviteCodeHint": "Contatta l'installatore o il personale di manutenzione per ottenere il codice di invito",
  // 密码修改与恢复
  "account.modifyPasswordByAccount": "Modifica password tramite account",
  "account.modifyPasswordByEmail": "Modifica password tramite email",
  "account.getPasswordByAccount": "Recupera password tramite account",
  "account.getPasswordByEmail": "Recupera password tramite email",

  "account.sendEmailTips": "Il codice di verifica è stato inviato all'email, verifica per favore",
  "account.name": "Nome account",
  "account.newPassword": "Nuova password",
  "account.confirmNewPassword": "Conferma nuova password",
  "account.nameTips": "Inserisci il nome account",
  "account.passwordModifySuccess": "Password modificata con successo",
  "account.emailCode": "Codice di verifica per email",
  "account.emailCodeTips": "Inserisci il codice di verifica per email",
  "account.emailCodeTips2": "Codice di verifica per email non valido",
  "account.emailModifySuccess": "Password modificata con successo",
  "account.passworTips1": "La tua password è stata reimpostata con successo!",
  "account.passwordTips11": "Inserisci la conferma della password",
  "account.passwordTips12": "Inserisci la nuova password",
  "account.nickname": "Nickname",
  "account.modifyNickname": "Modifica nickname",
  "account.modifyNicknameSuccess": "Nickname modificato con successo!",
  "account.nicknameTips": "Inserisci il nickname",
  "account.nicknameError": "Errore nella modifica del nickname!",

  // 快速注册与登录
  "account.login": "Accedi",
  "account.quickRegister": "Registrazione rapida",
  "account.sendCode": "Ottieni codice",
  "account.sendTips": "Puoi inviare di nuovo tra s secondi",
  "account.sendEmailIng": "Invio email in corso... Attendi, per favore...",
  "account.emailNotEmpty": "L'indirizzo email non può essere vuoto",
  "account.registerAccount": "Registrazione account",
  "account.registerWelcome": "Benvenuto nella registrazione di SusprSafe",
  "account.usernameLimit": "Il nome utente deve iniziare con una lettera e può contenere solo lettere, numeri e underscore, lunghezza 5-15 caratteri",

  // 版权信息
  "copyright.desc2": "Informazioni sulla registrazione del sito: Registrazione ICP della Provincia di Guangdong n. 2021169764",

  // 用户信息编辑
  "editUserInfo.editUserInformation": "Modifica informazioni utente",
  "editUserInfo.modifyUsername": "Modifica nome utente",
  "editUserInfo.changePictures": "Cambia immagine profilo",
  "editUserInfo.savePicturesSuccess": "Immagine profilo salvata con successo",
  "editUserInfo.saveError": "Salvataggio fallito",
  "editUserInfo.pictureLimit": "La dimensione dell'immagine deve essere inferiore a 2 MB",
  "editUserInfo.uploadPicture": "Carica immagine profilo",
  "editUserInfo.picturePreview": "Anteprima",
  
  "editUserInfo.bindPhoneNumber": "Associa numero di telefono",
  "editUserInfo.bindEmail": "Associa email",
  "editUserInfo.changePassword": "Modifica password",

  "editUserInfo.notificationSettings": "Impostazioni notifiche",
  "editUserInfo.editAccount": "Modifica informazioni account utente",
  "editUserInfo.waitBingting": "Associazione in corso... Attendi, per favore...",
  "editUserInfo.collapse": "Comprimi",
  "editUserInfo.modifyBinding": "Modifica associazione",
  
  "editUserInfo.emailAddress": "Indirizzo email",
  "editUserInfo.tips1": "Email associata con successo",
  "editUserInfo.tips2": "Salvataggio fallito",
  "editUserInfo.tips3": "Invio codice di verifica per email in corso... Attendi, per favore...",
  "editUserInfo.tips4": "Il codice di verifica è stato inviato all'email xxxx, verifica per favore",
  "editUserInfo.tips5": "Errore nell'invio del codice di verifica!",
  "editUserInfo.tips6": "Il numero di telefono è già associato",
  "editUserInfo.tips7": "L'email è già associata",
  "editUserInfo.emailTips1": "Inserisci l'indirizzo email",
  "editUserInfo.emailTips2": "Formato email non valido",
  "editUserInfo.emailTips3": "Puoi inviare di nuovo tra xxxx secondi",
  "editUserInfo.emailTips4": "Ottieni codice",
  "editUserInfo.emailTips5": "Il codice di verifica per email non può essere vuoto",
  "editUserInfo.emailTips6": "Codice di verifica per email non valido",
  "editUserInfo.emailCode": "Codice di verifica per email",
  "editUserInfo.save": "Salva",

  // 手机绑定相关
  "editUserInfo.phoneTips1": "Numero di telefono associato con successo",
  "editUserInfo.phoneTips2": "Invio codice di verifica SMS in corso... Attendi, per favore...",
  "editUserInfo.phoneTips3": "Il codice di verifica SMS è stato inviato al numero xxxx, verifica per favore",
  "editUserInfo.phoneTips4": "Errore nell'invio del codice di verifica SMS!",
  "editUserInfo.phoneTips5": "Inserisci il numero di telefono",
  "editUserInfo.phoneTips6": "Formato numero di telefono non valido",
  "editUserInfo.phoneTips7": "Ottieni codice SMS",
  "editUserInfo.phoneTips8": "Codice di verifica SMS",
  "editUserInfo.phoneTips9": "Il codice di verifica SMS non può essere vuoto",
  "editUserInfo.phoneTips10": "Codice di verifica SMS non valido",
  "editUserInfo.phone": "Numero di telefono",


  // 通知设置
  "editUserInfo.noticeTips1": "Errore nel recupero delle impostazioni di notifica!",
  "editUserInfo.noticeTips2": "Impostazioni di notifica salvate con successo!",
  "editUserInfo.noticeTips3": "Notifica sul livello basso della batteria",
  "editUserInfo.noticeTips4": "Notifica sul completamento della carica del caricabatterie",
  "editUserInfo.errorNotification": "Notifica di errore",
  "editUserInfo.updateNotification": "Notifica di aggiornamento",
  "editUserInfo.monthlyStatisticsNotification": "Notifica sulle statistiche mensili",
  "editUserInfo.notificationMethod": "Metodo di ricezione",

  // 用户名相关提示
  "editUserInfo.userNameTips1": "Nome utente salvato con successo",
  "editUserInfo.userNameTips2": "Salvataggio del nome utente fallito",
  "editUserInfo.userNameTips3": "Inserisci il nome utente",
  "editUserInfo.userNameTips4": "Formato nome utente non valido: può contenere solo numeri, underscore e lettere inglesi",
  "editUserInfo.userNameTips5": "Inserisci il nome utente",
  "editUserInfo.userNameTips6": "Salvataggio in corso... Attendi, per favore...",
  "editUserInfo.userName": "Nome utente",

  // 头像编辑提示
  "editUserInfo.avatorTips": "Clicca per cambiare l'immagine profilo",
  "editUserInfo.verifyCodeTips1": "Inserisci il codice di verifica ricevuto:",
  "editUserInfo.verifyCodeTips2": "Per la sicurezza del tuo account, clicca il pulsante qui sotto per inviare il codice di verifica al numero di telefono originale:",
  "editUserInfo.verifyCodeTips3": "Ottieni codice",
  "editUserInfo.verifyCodeTips4": "Verifica del numero di telefono originale effettuata con successo, inserisci il nuovo numero di telefono associato",
  "editUserInfo.verifyCodeTips5": "Per la sicurezza del tuo account, clicca il pulsante qui sotto per inviare il codice di verifica all'email originale:",
  "editUserInfo.verifyCodeTips6": "Verifica dell'email originale effettuata con successo, inserisci la nuova email",
  "editUserInfo.verifyCodeTips7": "Password vecchia",
  "editUserInfo.verifyCodeTips8": "Associa prima l'email!",
  "editUserInfo.verifyCodeTips9": "Il codice di verifica è stato inviato all'email, verifica per favore",
  "editUserInfo.verifyCodeTips10": ", sarai reindirizzato automaticamente alla pagina di accesso",

  // 通知相关
  "hems.notice.title": "Titolo notifica", 
  "hems.notice.content": "Contenuto notifica", 
  "hems.notice.operate": "Operazione",
  "hems.notice.noRead": "Non letto",
  "hems.notice.read": "Letto",
  "hems.notice.warning": "Avviso",
  "hems.notice.error": "Errore",
  "hems.notice.success": "Calcolo statistiche",
  "hems.notice.sys": "Informazioni di sistema",
  "hems.notice.operateSuccess": "Operazione effettuata con successo",
  "hems.notice.operateTips": "Seleziona l'elemento per l'operazione",

  // 首页
  "hems.home.selfuseRate": "Tasso di autoconsumo",
  "hems.home.percent": "Percentuale",
  "hems.home.todayData": "Dati di oggi",
  "hems.home.todayPowerGeneration": "Produzione energetica di oggi",
  "hems.home.salesIncome": "Reddito dalla vendita di energia",
  "hems.home.saved": "Hai risparmiato",
  "hems.home.reduce": "Riduci l'impronta di carbonio",
  "hems.home.tips1": "Nessun dato disponibile al momento, non hai ancora associato xxxx",
  "hems.home.criticalLoad": "Carico critico",
  "hems.home.keyVoltage": "Tensione critica",
  "hems.home.householdLoad": "Carico domestico",
  "hems.home.householdVoltage": "Tensione domestica",
  "hems.home.generalLoad": "Carico generale",
  "hems.home.generalVoltage": "Tensione generale",
  "hems.home.batteryHealth": "Stato di salute della batteria",
  "hems.home.averageTemp": "Temperatura media",
  "hems.home.gridLoad": "Carico della rete elettrica",
  "hems.home.toggeleDataSource": "I dati visualizzati sono stati modificati in:",
  "hems.home.toggleTips": "Sei sicuro di voler modificare?",
  "hems.home.modeSending": "Invio comando modalità in corso... Attendi, per favore...",
  "hems.home.modeSuccess": "Comando di modifica modalità inviato con successo!",
  "hems.home.isOnline": "Sei online?",
  "hems.home.useStatus": "Stato di utilizzo",
  "hems.home.workModeText": "Modalità di lavoro attuale:",
  "hems.home.toggleDataSourceText": "I dati visualizzati sono stati modificati in:",
  "hems.ev.charge.status": "Stato di carica",
  "hems.ev.charge.time": "Tempo di carica",
  "hems.ev.charge.count": "Quantità di carica in tempo reale",
  "hems.ev.charge.status.empty": "Vuoto",
  "hems.ev.charge.status.ing": "Caricamento con cavo associato",
  "hems.ev.charge.status.null": "Cavo associato, ma senza carica",
  "hems.ev.charge.status.error": "Errore",
  "hems.hour": "ora",
  "hems.minue": "minuto",
  "hems.ev.chagre.number": "Numero caricabatterie",

  // 用户指南
  "hems.userGuide.selfUse": "Autoconsumo di energia prodotta",
  "hems.userGuide.selfUseTips": "Usa prima l'energia fotovoltaica; se non è sufficiente, completa con la rete elettrica",
  "hems.userGuide.economyMode": "Modalità economica",
  "hems.userGuide.economyModeTips": "Ottimizza la strategia di consumo energetico in base al prezzo dell'energia elettrica",
  "hems.userGuide.emergencyMode": "Modalità di emergenza",
  "hems.userGuide.emergencyModeTips": "Dai priorità al rifornimento energetico per il carico critico prima di tutto",

  // 图表页面
  "hems.history.energyStatistics": "Statistiche energetiche",
  "hems.history.revenueStatistics": "Statistiche dei redditi",
  "hems.history.greenStatistics": "Riduzione delle emissioni verdi",
  "hems.history.revenueTitle": "Reddito totale dalla vendita di energia",
  "hems.history.savingsTitle": "Risparmio totale",
  "hems.history.carbonTitle": "Riduzione totale di carbonio",
  "hems.history.day": "Giorno",
  "hems.history.month": "Mese",
  "hems.history.year": "Anno",
  "hems.history.beforeDay": "Ieri",
  "hems.history.afterDay": "Domani",
  "hems.history.beforeMonth": "Mese precedente",
  "hems.history.afterMonth": "Mese successivo",
  "hems.history.beforeYear": "Anno precedente",
  "hems.history.afterYear": "Anno successivo",
  "hems.history.totalUse": "Utilizzo totale",
  "hems.history.fullScreen": "Schermo intero",
  "hems.history.timeSelect": "Seleziona data",
  "sync.tips1": "Comando di sincronizzazione dati inviato con successo!",
  "sync.tips2": "Sincronizzazione dati in corso; a causa del volume di dati elevato, è necessaria del tempo, verifica di nuovo tra mezz'ora~",
  "sync.tips3": "La sincronizzazione dati del dispositivo può avere un ritardo; se noti discrepanze nei dati, clicca su:",
  "sync.tips4": "Sincronizza dati",

  // 充电桩信息
  "charge.info": "Informazioni sul caricabatterie",
  "news.loading": "Caricamento in corso...",
  "news.noMore": "Nessun altro dato disponibile",
  "hems.pv.power": "Quantità di energia fotovoltaica",

  // UEH特定功能
  "ueh.sellPower": "Quantità di energia venduta",
  
  // 菜单
  "menu.home": "Home",
  "menu.history": "Storico dati",
  "menu.device": "Dispositivi",
  "menu.settings": "Impostazioni",
  "menu.messageCenter": "Centro messaggi",
  "menu.help": "Aiuto e supporto",
  "menu.mine": "Mio",


  // 我的设置
  "mine.userSetting": "Impostazioni utente",
  "mine.terminalSetting": "Impostazioni base del terminale",
  "mine.uploadCloud": "Carica dati sulla nuvola",
  "mine.changeVersion": "Verifica aggiornamenti",
  "mine.language": "Cambia lingua",
  "mine.about": "Informazioni sull'app",
  "mine.feedback": "Feedback",
  "mine.logout": "Esci",
  "mine.logoutAccount": "Elimina account",

  // 注销账户相关
  "mine.logoutAccountTips": "Elimina account con nome []",
  "mine.logoutAccountTips1": "Elimina account associato a []",
  "mine.logoutAccountCare": "Note sulla richiesta di eliminazione account:",
  "mine.logoutAccountCare1": "1. L'account è in stato sicuro",
  "mine.logoutAccountCare1-1": "L'account è in modalità di utilizzo normale, senza rischi di furto, violazioni di regole o blocco.",
  "mine.logoutAccountCare2": "2. Autorizzazioni e associazioni dell'account sono state rimosse",
  "mine.logoutAccountCare2-1": "Tutte le autorizzazioni dell'account per le piattaforme di terze parti sono state rimosse.",
  "mine.logoutAccountCare3": "3. Dopo l'eliminazione, l'account non può essere recuperato, i dati utente saranno eliminati",
  "mine.logoutAccountCare3-1": "Dopo l'eliminazione, i numeri di telefono associati, le email e altri dati saranno eliminati e non recuperabili.",
  "mine.confirmLogout": "Conferma eliminazione",
  "mine.logoutSuccess": "Account eliminato con successo!",


  // 反馈问题
  "mine.feedbackIssues": "Feedback sui problemi",
  "mine.feedQuantity": "Quantità",
  "mine.feedAmount": "Massimo 9 immagini, dimensione massima 1 MB per immagine",

  // 通知设置相关
  "mine.notice.fail": "Errore nel recupero delle impostazioni di notifica!",
  "mine.notice.saveSuccess": "Impostazioni di notifica salvate con successo!",
  "mine.notice.saveFail": "Salvataggio fallito!",
  "mine.notice.title": "Impostazioni di notifica",
  "mine.notice.batteryLow": "Notifica sul livello basso della batteria",
  "mine.notice.chargingFinish": "Notifica sul completamento della carica del caricabatterie",
  "mine.notice.error": "Notifica di errore",
  "mine.notice.update": "Notifica di aggiornamento",
  "mine.notice.monthly": "Notifica sulle statistiche mensili",
  "mine.notice.receiveType": "Metodo di ricezione",

  // 语言设置欢迎语
  "mine.language.welcome": "Benvenuto in SusprSafe",
  "mine.language.desc1": "Seleziona la versione lingua in base alla tua residenza",
  "mine.language.desc2": "Puoi cambiarla in qualsiasi momento nelle impostazioni dell'app",

  // 个人信息
  "mine.userInfo.avatar": "Immagine profilo",
  "mine.userInfo.nickname": "Nickname",
  "mine.userInfo.password": "Password",
  "mine.userInfo.changePassword": "Modifica password",
  "mine.userInfo.setPassword": "Imposta password",
  "mine.userInfo.phoneNumber": "Numero di telefono",
  "mine.userInfo.bindPhone": "Associa numero di telefono",
  "mine.userInfo.bindEmail": "Associa email",
  "mine.loginExpired": "La sessione è scaduta, accedi di nuovo",
  "mine.userInfo.title": "Informazioni utente",
  "mine.userInfo.bind": "Associa",
  "mine.userInfo.modify": "Modifica",
  "mine.userInfo.modifyNickname": "Modifica nickname",
  "mine.userInfo.userNickname": "Nickname utente",
  "mine.userInfo.selectPic": "Seleziona un'immagine da caricare",
  "mine.userInfo.saveSuccess": "Salvataggio effettuato con successo",
  "mine.userInfo.uploadFail": "Caricamento fallito",
  "mine.userInfo.avatarSaveSuccess": "Immagine profilo salvata con successo",
  "mine.userInfo.nameTips1": "Il nickname non può essere vuoto",
  "mine.userInfo.nameTips2": "Inserisci il nickname",

  // 通用选择提示
  "common.pleaseSelect": "Seleziona, per favore",
  "question.commonQuestions": "Domande frequenti",
  "account.toggleLanguage": "Cambia lingua",
  "account.localConnection": "Connessione locale",
  "account.selectLanguage": "Seleziona la lingua, per favore",
  "account.sendEmailToast": "Il codice di verifica è stato inviato all'email xxx, verifica per favore",
  "account.emailError": "Formato email non valido",
  "account.sendEmailFail": "Invio fallito, riprova per favore",
  
  "common.submitting": "Invio in corso... Attendi, per favore...",

  "device.page.noData": "Nessun dato disponibile al momento; questa pagina può essere visualizzata solo nell'app",

  // OTA Upgrade
  "bmsFirmware.upgrade": "Aggiorna",
  "bmsFirmware.upgrading": "Aggiornamento in corso...",
  "bmsFirmware.uploadingFile": "Caricamento file firmware...",
  "bmsFirmware.upgradingProgress": "Aggiornamento firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Aggiornamento riuscito",
  "bmsFirmware.upgradeSuccessSubtitle": "Aggiornamento firmware BMS completato!",
  "bmsFirmware.upgradeFailed": "Aggiornamento fallito",
  "bmsFirmware.upgradeFailedFormError": "Verifica se il modulo è compilato correttamente",
  "bmsFirmware.upgradeFailedNetworkError": "Errore di rete, riprova",
  "bmsFirmware.invalidFileType": "Seleziona un file firmware valido (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Seleziona prima un file firmware",
  "bmsFirmware.statusUpgrading": "Aggiornamento in corso",
  "bmsFirmware.statusCompleted": "Aggiornamento completato",
  "bmsFirmware.statusFailed": "Aggiornamento fallito",
  "bmsFirmware.deviceUpgrading": "Aggiornamento pacchetto firmware in corso, l'aggiornamento richiede 30-50 minuti, i dati del dispositivo in tempo reale non possono essere visualizzati durante questo periodo, attendere...",
  "bmsFirmware.upgradeStatusLabel": "Stato aggiornamento",
  "bmsFirmware.upgradeProgressLabel": "Progresso aggiornamento",
  "bmsFirmware.currentPackageLabel": "Numero pacchetto dati attualmente trasmesso",
  "bmsFirmware.totalPackagesLabel": "Numero totale pacchetti dati",
  "bmsFirmware.upgradeFailedCheckDevice": "Verifica lo stato del dispositivo e riprova l'aggiornamento",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Impostazione riuscita",
  "settingResult.defaultSubTitle": "Impostazioni parametri salvate",
  "settingResult.confirmButton": "OK"
};